(function () {
  'use strict';

  // 经销商登录后购物车重定价同步（2026-08-27 Phase B 最终形态）。
  //
  // 背景：Shopify 购物车行价在“登出→登录”买家上下文变化时【不会自动重算】（与切档残留
  // 同源）；且 storefront 会话的 B2B 标志（customer.b2b?/buyer_flags）仅在【进入结账】时被
  // 建立（L1/H2 实测），登录页 dealer=false。
  //
  // 本模块能力：
  //  A) 登录 completed 触发（handleLogin）：若当前页 TTC_AUTH.dealer===false → 先整页 reload 一次
  //     （reload 前写 sessionStorage 指纹防循环）；reload 后 dealer=true 则由 trigger D 自愈，
  //     若 dealer 仍 false（平台未附着/未访问过结账）→ 保留现状（平台边界，文档记录）。
  //  B) trigger D（页面加载自愈检测）：DOMContentLoaded/模块初始化时，若 TTC_AUTH.dealer===true 且
  //     购物车非空：fetch /cart.js → expectedNetTotal=Σ round(item.final_line_price×(100−F)/80)
  //     （F=TTC_AUTH.finalPercent），若 |total_price−expected|>1 分 → 执行重评（cart/change 白名单
  //     payload）+ 硬校验 + 分区重渲染 + overlay。每 auth 指纹每页最多 1 次（sessionStorage）。
  //  C) net_enabled 前置条件：无 gift/selling_plan、且购物车仅允许 TTC Dealer Final 折扣，否则跳过。
  //  D) 与登录触发共用单次令牌/冷却/Web Locks（navigator.locks 'ttc-auth-reprice'）；payload 白名单
  //     强校验；执行期抑制自身 observer（不抑制 addon-note observer）。
  //
  // window.TTC_AUTH 由 layout/theme.liquid 注入：{dealer, finalPercent, repriceEndpoint}。

  var AUTH = window.TTC_AUTH || {};
  var dealerInitially = !!AUTH.dealer;          // 页面初始是否 dealer 渲染
  var finalPercent = AUTH.finalPercent || null;
  var ALLOWED_ENDPOINTS = ['cart/change', 'cart/update'];
  var selectedEndpoint = (AUTH.repriceEndpoint && ALLOWED_ENDPOINTS.indexOf(AUTH.repriceEndpoint) !== -1)
    ? AUTH.repriceEndpoint : 'cart/change';
  var RUNNING = false;                          // 执行期抑制（重入/自压抑）
  var RELOADED = false;                         // 登录触发 reload 已做（本页）标记
  var LOCK_KEY = 'ttc-auth-reprice';
  var LOGIN_RELOAD_KEY = 'ttc-auth-login-reload-done';   // 登录先 reload 防循环
  var REPRICE_DONE_KEY = 'ttc-auth-reprice-done';        // 每 auth 指纹每页最多 1 次
  var overlay = null;
  var observer = null;

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  // 期望单行净价 = round(final_line_price × (100−F)/80)。F 需 20<F<100，否则回 null。
  function lineNet(lineFinalPrice, f) {
    var flp = Number(lineFinalPrice);
    if (!Number.isFinite(flp) || flp < 0) return null;
    var F = Number(f);
    if (!Number.isFinite(F) || F <= 20 || F >= 100) return null;
    return Math.round(flp * (100 - F) / 80);
  }

  // 期望净总价 = Σ round(item.final_line_price×(100−F)/80)。
  function expectedNetTotalFromCart(cart, f) {
    if (!cart || !Array.isArray(cart.items)) return null;
    var sum = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var ln = lineNet(cart.items[i].final_line_price, f);
      if (ln === null) return null;
      sum += ln;
    }
    return sum;
  }

  // 兼容：hardVerify 用的单值版本（旧签名）。
  function expectedNetTotal(originalTotal) {
    var F = Number(finalPercent);
    if (!Number.isFinite(F) || F <= 20 || F >= 100) return null;
    var n = Number(originalTotal);
    if (!Number.isFinite(n) || n <= 0) return null;
    return Math.round(n * (100 - F) / 80);
  }

  // net_enabled 前置：非空购物车、无 gift/selling_plan、仅 TTC Dealer Final 折扣。
  function netEnabledOk(cart) {
    if (!cart || !Array.isArray(cart.items) || !cart.items.length) return false;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.gift_card) return false;
      if (it.selling_plan_allocation) return false;
    }
    var apps = cart.cart_level_discount_applications || [];
    for (var j = 0; j < apps.length; j++) {
      var title = String(apps[j].title || '');
      if (title.indexOf('TTC Dealer Final') !== 0) return false;
    }
    return true;
  }

  // trigger D 判定：|total_price − expected(sum of line nets)| > 1 分。
  function needsReprice(cart) {
    var f = Number(finalPercent);
    if (!Number.isFinite(f) || f <= 20 || f >= 100) return { needs: false, expected: null };
    if (!netEnabledOk(cart)) return { needs: false, expected: null };
    var expected = expectedNetTotalFromCart(cart, f);
    if (expected === null) return { needs: false, expected: null };
    var need = Math.abs(cart.total_price - expected) > 1;
    return { needs: need, expected: expected };
  }

  // 硬校验：key/qty/note 不变，且 total === Σ round(item.final_line_price×(100−F)/80)（当前 F 的期望净总价）。
  // 仅靠“有折扣/有变化”会被粘滞旧档折扣误判，故以“等于当前 F 的期望净总价”为决定性条件。
  function hardVerify(before, after) {
    if (!after || !before) return false;
    var bItems = before.items || [];
    var aItems = after.items || [];
    if (bItems.length !== aItems.length) return false;
    for (var i = 0; i < bItems.length; i++) {
      if (bItems[i].key !== aItems[i].key) return false;
      if (bItems[i].quantity !== aItems[i].quantity) return false;
    }
    if ((before.note || '') !== (after.note || '')) return false;
    var exp = expectedNetTotalFromCart(after, finalPercent);
    return exp !== null && Math.abs(after.total_price - exp) <= 1;
  }

  // payload 白名单强校验：仅 {line:int>0,quantity:int>0} 或 {note:string}。
  function validatePayload(payload) {
    if (!payload || typeof payload !== 'object') return false;
    var keys = Object.keys(payload);
    if (keys.length === 2 && 'line' in payload && 'quantity' in payload) {
      var l = Number(payload.line), q = Number(payload.quantity);
      if (!Number.isInteger(l) || l < 1) return false;
      if (!Number.isInteger(q) || q < 1) return false;
      return true;
    }
    if (keys.length === 1 && 'note' in payload) {
      return typeof payload.note === 'string';
    }
    return false;
  }

  // 每 auth 指纹：dealer/F/template + 购物车行数量，供“每页最多 1 次”。
  function fingerprint() {
    var parts = [window.TTC_TEMPLATE || '', String(finalPercent)];
    try {
      parts.push(String(document.querySelectorAll('.cart-item, main-cart-item, [data-ttc-final-percent]').length));
    } catch (e) {}
    return parts.join('|');
  }
  function getDoneFp() { try { return sessionStorage.getItem(REPRICE_DONE_KEY) || ''; } catch (e) { return ''; } }
  function setDoneFp() { try { sessionStorage.setItem(REPRICE_DONE_KEY, fingerprint()); } catch (e) {} }
  function doneForThisPage() { return getDoneFp() === fingerprint(); }
  function getLoginReloadDone() { try { return sessionStorage.getItem(LOGIN_RELOAD_KEY) === '1'; } catch (e) { return false; } }
  function setLoginReloadDone() { try { sessionStorage.setItem(LOGIN_RELOAD_KEY, '1'); } catch (e) {} }

  function overlayOn() {
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'ttc-auth-cart-overlay';
      overlay.setAttribute('role', 'status');
      overlay.textContent = 'Syncing dealer pricing…';
    }
    overlay.style.display = 'flex';
    document.body.appendChild(overlay);
  }
  function overlayOff() {
    if (overlay) overlay.style.display = 'none';
  }

  function postEndpoint(payload) {
    if (!validatePayload(payload)) return Promise.reject(new Error('invalid payload'));
    if (selectedEndpoint === 'cart/update') {
      return fetch(routes.cart_update_url || '/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
      }).then(function (r) { return r.json(); });
    }
    return fetch(routes.cart_change_url || '/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  // 行指纹 = items key+qty + note，用于竞态校验（用户编辑/购物车变化时 abort）。
  function rowFingerprint(cart) {
    if (!cart || !Array.isArray(cart.items)) return '';
    var keys = cart.items.map(function (it) { return it.key + ':' + it.quantity; });
    return JSON.stringify(keys) + '|' + (cart.note || '');
  }

  // 购物车 qty 输入/编辑区是否有焦点 → 跳过 trigger D（避免用户正在编辑时重评）。
  function activeElementInCartEditing() {
    try {
      var ae = document.activeElement;
      if (!ae || !ae.matches) return false;
      if (ae.matches('input, textarea, select') && ae.closest('.cart-item, cart-items, main-cart-items, [data-index]')) return true;
    } catch (e) {}
    return false;
  }

  function doReprice(snapshot) {
    return getCart().then(function (current) {
      // 竞态：POST 前重新 fetch，校验行指纹与 needsReprice 快照完全一致；
      // 不一致 → abort（用户正在编辑或购物车已变，本次放弃，下轮页面加载再试）。
      if (rowFingerprint(current) !== rowFingerprint(snapshot)) {
        return { aborted: true, before: snapshot, after: current };
      }
      var payload;
      if (selectedEndpoint === 'cart/update') {
        payload = { note: current.note || '' };
      } else {
        var qty = (current.items && current.items[0]) ? current.items[0].quantity : 1;
        payload = { line: 1, quantity: qty };
      }
      return postEndpoint(payload).then(function () {
        return getCart().then(function (after) { return { before: current, after: after }; });
      });
    });
  }

  function reprice(snapshot) {
    if (RUNNING) return Promise.resolve({ skipped: true });
    function runLock() {
      RUNNING = true;
      overlayOn();
      return doReprice(snapshot).catch(function (err) { RUNNING = false; overlayOff(); throw err; });
    }
    if (navigator.locks && navigator.locks.request) {
      return navigator.locks.request(LOCK_KEY, { ifAvailable: true }, runLock);
    }
    return runLock();
  }

  function attempt(attemptNo, snapshot) {
    function go(snap) {
      reprice(snap).then(function (r) {
        if (r.skipped || r.aborted) { RUNNING = false; overlayOff(); return; }   // abort：本次放弃，下轮页面加载再试
        RUNNING = false;
        if (hardVerify(r.before, r.after)) {
          overlayOff();
          setDoneFp();
          finish(r);
        } else if (attemptNo < 1) {
          setTimeout(function () { attempt(attemptNo + 1, r.before); }, 800);
        } else {
          // 硬校验失败：保留现状（不强制改动），但仍标记 done 避免无限重试。
          overlayOff();
          setDoneFp();
        }
      }).catch(function () { RUNNING = false; overlayOff(); });
    }
    if (snapshot) go(snapshot);
    else getCart().then(go);
  }

  function finish(result) {
    // 分区重渲染：广播 cartUpdate（source='ttc-auth-reprice'，cart.js 忽略）。
    if (window.publish && window.PUB_SUB_EVENTS) {
      try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ttc-auth-reprice', cartData: result.after }); } catch (e) {}
    }
    // 登录路径：页面初始非 dealer 渲染 → 整页 reload 一次让 dealer DOM 生效（PDP/购物车自愈）。
    if (!dealerInitially && !RELOADED) {
      RELOADED = true;
      window.location.reload();
    }
  }

  // trigger D：页面加载自愈检测。
  function tryTriggerD() {
    if (!dealerInitially) return;          // 非 dealer 渲染页不触发
    if (doneForThisPage()) return;         // 每 auth 指纹每页最多 1 次
    if (activeElementInCartEditing()) return;   // 焦点在购物车 qty 编辑区 → 跳过
    getCart().then(function (cart) {
      var nr = needsReprice(cart);
      if (nr.needs) {
        attempt(0, cart);                    // 用 needsReprice 的快照做竞态校验
      } else {
        setDoneFp();                        // 无需重评，标记避免反复检查
      }
    }).catch(function () {});
  }

  function handleLogin() {
    if (!window.TTCAuthSync || typeof window.TTCAuthSync.run !== 'function') {
      window.location.reload();             // 模块未就绪兜底 reload
      return;
    }
    window.TTCAuthSync.run();
  }

  function run() {
    // 登录触发顺序修正：当前页未 dealer 渲染 → 先整页 reload 一次（防循环），由 reload 后 trigger D 处理。
    if (!dealerInitially) {
      if (!RELOADED && !getLoginReloadDone()) {
        RELOADED = true;
        setLoginReloadDone();
        window.location.reload();
      }
      // reload 后 dealer=true → init/tryTriggerD 自愈；dealer 仍 false → 平台边界，保留现状。
      return;
    }
    attempt(0);
  }

  window.TTCAuthSync = {
    handleLogin: handleLogin,
    run: run,
    reprice: reprice,
    hardVerify: hardVerify,
    validatePayload: validatePayload,
    expectedNetTotal: expectedNetTotal,
    expectedNetTotalFromCart: expectedNetTotalFromCart,
    netEnabledOk: netEnabledOk,
    needsReprice: needsReprice,
    tryTriggerD: tryTriggerD,
    rowFingerprint: rowFingerprint,
    activeElementInCartEditing: activeElementInCartEditing,
    getEndpoint: function () { return selectedEndpoint; },
    isReloaded: function () { return RELOADED; }
  };

  // 次要触发：登录态变化（data-ttc-auth-state: logged_out -> logged_in），仅在非 dealer 渲染页触发 run；
  // RUNNING 期间抑制（避免重入）；不抑制 addon-note observer。
  function watchAuthState() {
    if (!window.MutationObserver || !document.querySelector) return;
    var targets = document.querySelectorAll('[data-ttc-auth-state]');
    if (!targets.length) return;
    observer = new MutationObserver(function (mutations) {
      if (RUNNING || RELOADED) return;
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (t.getAttribute && t.getAttribute('data-ttc-auth-state') === 'logged_in' && !dealerInitially) {
          run();
          return;
        }
      }
    });
    targets.forEach(function (t) { observer.observe(t, { attributes: true, attributeFilter: ['data-ttc-auth-state'] }); });
  }

  function init() {
    watchAuthState();
    tryTriggerD();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
